/**
 * Shared query factory used by multiple features (import, media-units).
 *
 * Rules:
 * - Each query key must be defined in exactly one canonical location.
 * - Features MUST import from here instead of redefining the same key.
 */
import { referenceData } from '@ooh/contracts';
import type { EndpointDef, callEndpoint } from '@ooh/contracts';

export interface WithCallWithAuth {
  callWithAuth: <TDef extends EndpointDef>(
    def: TDef,
    request: Parameters<typeof callEndpoint<TDef>>[1],
    options?: { signal?: AbortSignal },
  ) => ReturnType<typeof callEndpoint<TDef>>;
}

export type MediaFormat = { id: number; label: string; code: string };

/**
 * Canonical query factory for GET /media-formats.
 * Shared between features/import and features/media-units.
 */
export function formatsQuery(auth: WithCallWithAuth) {
  return {
    queryKey: ['media-formats'] as const,
    queryFn: ({ signal }: { signal: AbortSignal }) =>
      auth.callWithAuth(referenceData.formats, {}, { signal }),
  };
}
